module.exports = __webpack_public_path__ + "img/TrolleyPrinterTray.6e140006.jpg";